import Box from "@mui/material/Box";
import useTheme from "@mui/material/styles/useTheme";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

export type StatsSummaryConfig = {
  useMobileBreakpoints?: boolean;
  imageSizeOverride?: number;
};

const StatSummary = ({
  title,
  imageUrl,
  value,
  onClick,
  config,
  valueColor = "secondary.main",
}: {
  title?: string;
  imageUrl: string;
  value: string;
  onClick?: () => void;
  config?: StatsSummaryConfig;
  valueColor?: string;
}) => {
  const theme = useTheme();
  const mobileWidthBreakpoint = config?.useMobileBreakpoints
    ? useMediaQuery(theme.breakpoints.down("sm"))
    : false;
  const titleVariant = mobileWidthBreakpoint ? "labelMedium" : "titleSmall";
  const valueVariant = mobileWidthBreakpoint ? "titleMedium" : "titleLarge";

  return (
    <Box
      onClick={onClick}
      sx={{
        minWidth: 120,
        cursor: onClick ? "pointer" : "inherit",
      }}
    >
      {title && (
        <Box mb={0.5}>
          <Typography
            variant={titleVariant}
            color="primary"
            sx={{ whiteSpace: "nowrap" }}
          >
            {title}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: "flex", alignItems: "stretch" }}>
        <Box
          component="img"
          alt=""
          src={imageUrl}
          sx={{
            height: config?.imageSizeOverride ?? { xs: 36, sm: 48 },
            width: config?.imageSizeOverride ?? { xs: 36, sm: 48 },
            display: "flex",
            backgroundColor: "white",
          }}
        />
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: valueColor,
            color: "secondary.contrastText",
          }}
        >
          <Typography variant={valueVariant}>{value}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StatSummary;
